//@ts-nocheck
import { ChangeEvent, FC } from 'react';

import { Switch, SwitchProps, SxProps, Theme } from '@mui/material';

interface IProps {
  props?: SwitchProps;
  value: boolean;
  setValue: (event: ChangeEvent<HTMLInputElement>) => void;
  sx?: SxProps<Theme>;
}

export const StyledSwitch: FC<IProps> = ({ value, setValue, sx }) => {
  return (
    <Switch
      defaultChecked={!!value}
      value={!!value}
      checked={!!value}
      onChange={setValue}
      sx={sx}
    />
  );
};
